





<template>
  <div>
    <vs-loading :loading="loading"></vs-loading>
    <vs-card >
      <div class="tw-flex tw-justify-between">
        <vs-select
            class=""
            label="Sayfada Gösterilecek Kayıt Sayısı"
            v-model="pageSize"
            @change="handlePageSizeChange"
        >
          <vs-select-item
              v-for="size in pageSizes"
              :key="size"
              :value="size"
              :text="size"
          />
        </vs-select>

        <vs-paginator
            v-if="meta"
            :meta="meta"
            @change="handlePageChange"
        ></vs-paginator>

      </div>
    </vs-card>
   

    <vs-card>
      <div slot="header">
        <div class="tw-flex tw-justify-between">
          <h3>Etkinlik Bilgileri</h3>

         <!-- <vs-button
              color="primary"
              type="filled"
              :to="{name: 'informations-create'}"
          >
            Yeni Ekle
          </vs-button> -->
        </div>
      </div>

      <div class="tw-flex tw-flex-wrap">
        <div class="tw-w-full tw-flex tw-justify-between tw-items-center">
          <div class="tw-flex">
            <vs-input
                placeholder="Arama (Etkinlik Adı)"
                v-model="search"
  v-on:keyup.enter="page = 1; get();"
              
            />

            <v-icon  @click="page = 1; get();" small >mdi-magnify</v-icon>  
          </div>

        </div>

        <div class="tw-w-full">
          <vs-divider></vs-divider>
        </div>

        <div class="tw-w-full lg:tw-w-4/5">
          <div v-if="loading">Loading...</div>

          <vs-table stripe :data="list">
            <template slot="header">
              <h3>Etkinlikler</h3>
            </template>
           <template slot="thead">
             
           <!--  <vs-th>Etkinlik ID</vs-th> -->
            <vs-th class="tarbuyutucu">Etkinlik Kayıt No.</vs-th>
               <vs-th class="tarbuyutucu">Tarih</vs-th>
                <vs-th>Saat</vs-th>
                 <vs-th >Yer</vs-th>
                <vs-th class="fontt3">Etkinlik Türü</vs-th>
               <vs-th class="fontt3">Etkinlik Adı</vs-th>
               <!--<vs-th>Sürdürülebilir Kalkınma Amaçları</vs-th> -->
                <vs-th class="denemeB">Oluşturan</vs-th>
                
                  
                      <vs-th class="btneklemeyp"></vs-th>
                  
            </template>
            <template slot-scope="{data}">



            




              <vs-tr  v-for="(item, i) in data" :key="i" >
                  <!--<vs-td :data="item.id">
                  <div class="fontt2" @click="show(item, i)">{{ item.id }}</div>
                </vs-td>-->
                 <vs-td class="idGenis" :data="item.id">
                  <div class="fontt2" @click="show(item, i)">{{ item.appealId }}</div>
                </vs-td>
                 <vs-td :data="item.startDate">
                  <div class="fontt2" @click="show(item, i)">{{ datefunc(item.startDate) }}</div>
                </vs-td>
                 <vs-td :data="item.startTime">
                  <div class="fontt" @click="show(item, i)">{{ item.startTime }}</div>
                </vs-td>
                  <vs-td :data="item.room">
                  <div class="fontt" @click="show(item, i)">{{ item.room }}</div>
                </vs-td>
                 <vs-td :data="item.eventType">
                  <div class="fontt" @click="show(item, i)">{{ item.eventType }}</div>
                </vs-td>
                
                   <vs-td :data="item.eventName">
                  <div class="fontt" @click="show(item, i)">{{ item.eventName }}</div>
                </vs-td>
                  <!--<vs-td :data="item.relations">
                  <div class="fontt" @click="show(item, i)">{{ item.relations }}</div>-->
                </vs-td>
                 <vs-td :data="item">
                  <div class="fontt" @click="show(item, i)">{{ checkPharan(item.createdBy) }}</div>
                </vs-td>
               
                 <vs-td class="secGenis" :data="item">
                  <vs-button class="secGenisButon" color="#46c93a" icon-pack="mdi" icon="mdi-favorite" @click="show(item, i)">Seç</vs-button>        
                </vs-td>
                
                
              </vs-tr>
            </template>
          </vs-table>

          <!--<vs-button type="gradient" color="danger" @click="removeAll">Tümünü Sil</vs-button>-->
        </div>
        
        <div class="tw-w-full lg:tw-w-1/5 lg:tw-pl-5">
       
          <vs-card v-if="selected">
         
            <div class="header1" >
              <h3>{{ selected.eventName }}</h3>
            </div>
            <div class="close-button" slot="header">
              <vs-row vs-justify="flex-end">
                <vs-button close type="gradient" color="danger" icon-pack="mdi" icon="mdi-favorite" @click="func">X &nbsp</vs-button>
              </vs-row>
            </div>
            
            <div>
            <div>
              <strong>Etkinlik Adı:</strong> {{ selected.eventName }}
                    </div>
              <div>
                 <strong>Etkinlik Türü:</strong> {{ selected.eventType }}
                  </div>
                 <div>
                    <strong>Katılım Durumu:</strong> {{ selected.individual }}
                     </div>  
                     <div>
                    <strong>Etkinlik Ortamı:</strong> {{ selected.place }}
                     </div> 
                     <div>
                    <strong>Hedef Kitle:</strong> {{ selected.target }}
                     </div> 
                     <div>
                    <strong>Fon:</strong> {{ selected.fon }}
                     </div> 
             
            </div>
            <div slot="footer">
              <vs-row >
                <vs-button class="butonlar" type="gradient" color="warning" icon-pack="mdi" icon="mdi-favorite" :to="{name: 'informations-show', params: {id: selected.id}}">Görev Ekle</vs-button>

              </vs-row>
              
              
              
             
            </div>
          </vs-card>
          
         <div v-else>
            <br />
            <vs-alert active="true" color="info">
              Görev eklemek için etkinlik seçiniz.
            </vs-alert>
          </div>
        </div>
      </div>

    </vs-card> 

  </div>
</template>


<script>
  import { paginatorMixin } from "@/mixins/paginatorMixin";
  import Appeal from "@/libs/appeals/Appeal";
  import Inst from "@/libs/insts/Inst";
  import User from "@/libs/users/User";
     import { isAuthenticated, getUserFromStorage } from '@/utils/Customs'


  export default {
    name: "appeals-index",
    title: "Beni Görevli Ekle",

    mixins: [
      paginatorMixin,
    ],

    data() {
      return {
        obj: new Appeal(),
        obj22: new Appeal(),
        obj2: new Inst(),
        user: getUserFromStorage(),
        obj3: new User(),
        search: "",
        loading: false,
        gonderilecek3:[],
        etkinlikListesi:[]
      };
    },

    computed: {
      users() {
        return this.obj3.users
      },
      appeals() {
        return this.obj.appeals
      },
      appealsEt() {
        return this.obj22.appeals
      },
      insts() {
        return this.obj2.insts
      },

      selected() {
        return this.obj.selected
      },

      saved() {
        return this.obj.saved
      },

      deleted() {
        return this.obj.deleted
      },

      list() {
        if(this.appealsEt && this.appealsEt.data){
             this.etkinlikListesi=this.appealsEt.data
        }
        
          if(this.appeals && this.appeals.data)
              return this.appeals.data.reverse()
        
        
         
         

        return []
      },
      list3() { 
        if(this.users && this.users.data){
          this.gonderilecek3=this.users.data
          return this.users.data
        }
        return []
      },

      meta() {
        if(this.appeals && this.appeals.meta){
          
          let f=this.list3
          return this.appeals.meta
        }
          

        return null
      },
       meta3  () {
        if(this.users && this.users.meta)
          return this.users.meta

        return null
      },

      

      
      submitted() {
        return this.obj.form.submitted
      },

      contaminated() {
        return this.obj.form.errorDetected
      }
    },

    watch: {
      contaminated(val) {
        this.loading = false
      },

      submitted(val) {
        if(val)
          this.loading = false
      },

      saved(val) {
        if(val)
          this.get()
      },

      deleted(val) {
        if(val)
          this.get()
      },
    },

    methods: {
      checkPharan(temp){
        var nameTemp=""+temp
        if(nameTemp != "undefined" || nameTemp != undefined ){
          if(nameTemp.includes('(')){
          return "Kurum"
        }
        return nameTemp
        }
        
          return "("+nameTemp+")"
        
        
      },
      datefunc(temp){
        var date = ""+temp
        if(temp){
            if(date.length>2){
            var newerdate=date.substring(0,10)
            var newdate = newerdate.split("-").reverse().join("-");
            
            return newdate
        }else{
          return ""
        }
        }else{
          return "-"
        }
        
       },
      idTempCal(item){
          let count=0;
           for (let i = 0; i <  this.appeals.data.length; i++) { 
            
            
            
              if(this.appeals.data[i].id == item.id){
                
               return this.$idTemp+i
              }
              
            }
      },
      etkinlikGoster(item,i){
          
          if(item.published =="Silindi"){         
            return false;
          }
          return true;
      },
      eklemeYap(item){
        
        this.$router.push({name: 'informations-create', params: {id: item.id, parametre2: this.gonderilecek3, parametre3: this.etkinlikListesi, parametre4: item.socials, parametre5: item.relations}})
        
      },
      eklemeYapGorev(item){
       
        this.$router.push({name: 'informations-show', params: {id: selected.id}})
        
      },
     
      silmeYap(itemid) {

        this.$confirm(
        {
          message: `Etkinliği Silmek İstiyor Musunuz?`,
          button: {
            no: 'Hayır',
            yes: 'Evet'
          },
          /**
          * Callback Function
          * @param {Boolean} confirm
          */
          callback: confirm => {
            if (confirm) {
             
              
        this.obj.delete(itemid)
            }
          }
        }
      )
        
      },
      get() {
        const params = this.getRequestParams(
          this.search,
          this.page,
         this.pageSize
        );

        this.loading = true
        this.obj.getAll(params)
      },
      getEtkinlik() {
          const params = this.getRequestParams(
          this.search,
          this.page,
          10
        );

        this.loading = false
        this.obj22.getAll(params)
      },
       get3() {
        const params = this.getRequestParams(
          this.search,
          this.page,
          10
        );

        this.loading = true
        this.obj3.getAll2(params)
      },
     

      handlePageChange(page) {
        this.page = page;
        
      
        this.get();
        let e=this.list
        
      },

      handlePageSizeChange() {
         
        this.page = 1;
        this.get();
        this.getEtkinlik();
       let e=this.list
      },

      refreshList() {
        this.get();
        this.getEtkinlik();
       let e=this.list
        this.obj.selected = null;
      },

      show(item, index) {
        this.obj.selected = item;
      },

      removeAll() {
        this.loading = true
        this.obj.deleteAll()
      },
      func(){
        this.obj.selected = null;
      }
    },
    
    mounted() {
      this.get();
      this.get3();
      this.getEtkinlik();
        
    }
  };
</script>

<style>
  .vs-component.vs-button.vs-button-danger.vs-button-gradient{
    color:white;
  }
  .vs-component.vs-button.vs-button-primary.vs-button-filled{
    color:white;
  }
  .vs-component.vs-button.vs-button-null.vs-button-filled{
    color:white;
  }
  .butonlar{
  margin-left:1%;
}
.butonlar1{
  width:100%;
  margin-left:1%;
}
.butonlar2{
  margin-left:1%;
}
.denemeB{
  width:13%;
}
.btneklemeyp{
  width:11%;
}
  .header1 {display:inline-block;margin-right:10px;} 
.close1 {text-align: center;}
.vs-pagination--li.is-current .effect{
      background-color: #E6272D !important;
      border-radius:25px;
  }

  .vs-input-number-primary button {
    background: #E6272D !important;
}

.tarbuyutucu{
  width:12%;
}
.secGenis{
  width: 12%;
}
.secGenisButon{
  width: 100%;
}
.idGenis{
   width: 15%;
}
</style>